import { useMutation, UseMutationOptions } from 'react-query';
import { mutateCloseMarket } from './closeMarket';
import { TCloseMarketBody } from './closeMarket.types';

export const useMutationCloseSportMarket = (
  options?: UseMutationOptions<unknown, unknown, TCloseMarketBody>
) => useMutation((data) => mutateCloseMarket(data), options);
